const langtrans={
      yhdl:["用户登录","User Login"],
      jyjg:["救援机构","Assistance agency"],
      jjgjg:["监管机构","Supervision organization"],
      zzzhzz:["指挥中心","Commander center"],
      zzzhzz1:["指挥中心：","Commander center"],
      gy:["关于","About us"],
      gsjj:["公司简介","Introduction to company"],
      xwzzx:["新闻中心","News center"],
      hgzzzz:["合作咨询","Cooperating consultation"],
      lxj:["联系","Contact Us"],
      yjxfk:["意见反馈","Feedback"],
      kffrx:["客服热线：","Customer service hotline:"],
      xzzddj:["下载大救星","Download Dajiuxing"],
      ddjxew:["大救星二维码","Download Dajiuxing"],
      wwxsgz:["微信公众号","WeChat Public Account"],
      ddjxww:["大救星微信公众号二维码","Scan QR Code for Dajiuxing WeChat Public Account"],
      ddjxbq:["大救星版权所有","Dajiuxing Copyright Owned"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/assets/languagejs/indexFooter.vue.trans.js